import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgClass } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MODAL_TOKEN, ModalProvider } from '@core';
import { ContactService } from '@profile/infra';
import { take } from 'rxjs';
import { ReportProfileCommandHandler } from '../../application/handlers';

@Component({
  selector: 'lib-report-profile-modal',
  templateUrl: './report-profile-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, ReactiveFormsModule, NgClass],
  providers: [ReportProfileCommandHandler, ContactService]
})
export class ReportProfileModalComponent {
  @Input() reportedUserId!: string;
  @Input() reportedDisplayName!: string;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly reportProfileCommandHandler: ReportProfileCommandHandler = inject(ReportProfileCommandHandler);

  readonly minLength: number = 10;

  readonly reportForm: FormGroup = new FormGroup({
    message: new FormControl('', [
      Validators.required,
      Validators.minLength(this.minLength),
      Validators.maxLength(1000)
    ])
  });

  get isMessageTooShort(): boolean {
    const control: FormControl = this.reportForm.get('message') as FormControl;
    return !!control.value && control.value.length < this.minLength;
  }

  submit(): void {
    if (!this.reportForm.valid) return;

    this.reportProfileCommandHandler
      .report(this.reportedUserId, this.reportedDisplayName, this.reportForm.get('message')?.value)
      .pipe(take(1))
      .subscribe(() => this.modalProvider.dismissModal$({ sent: true }));
  }

  close(): void {
    this.modalProvider.dismissModal$();
  }
}
